import {
    TOKEN_EXITOSO
    ,TOKEN_ERROR
    ,REGISTRO_EXITOSO
    ,REGISTRO_ERROR  
    ,OBTENER_USUARIO 
    ,LOGIN_EXITOSO  
    ,RECUPERAR_EXITOSO
    ,RECUPERAR_ERROR 
    ,LOGIN_ERROR     
    ,CERRAR_SESION   
} from '../../types';

const getAccesos = ( id ) => {
    switch( id ) {
        case 35014:
            return [
                {id: 1, acceso: 'Mis pacientes', link: '/pacientes'},
                {id: 2, acceso: 'Registro clientes', link: '/prospectos'}
            ]
        case 35016:
            return [
                {id: 1, acceso: 'Resultados', link: '/resultados'},
                {id: 2, acceso: 'Citas', link: '/citas'}
            ]
        default:
            return null;
    }
}

export default ( state, action ) => {

    switch(action.type) {
        case TOKEN_EXITOSO:
            localStorage.setItem('token', action.payload);
            return {
                ...state,
                autenticado: null,
                recuperoContraseña:null,
                mensaje: null,
                cargando: false,
            }
        case REGISTRO_EXITOSO:
            
        case RECUPERAR_EXITOSO:
            localStorage.removeItem('token');
            localStorage.removeItem('usuario');
            return {
                ...state,
                token: null,
                usuario: null,
                autenticado: null,
                mensaje: action.payload,
                cargando: false,
                accesos: null,
                recuperoContraseña: true
            }

        case LOGIN_EXITOSO:
            localStorage.setItem('usuario', JSON.stringify(action.payload));
            return {
                ...state,
                autenticado: true,
                mensaje: null,
                usuario: action.payload,
                cargando: false,
                accesos: getAccesos(
                    action.payload ?
                        action.payload.clasificacionId
                        :
                        JSON.parse( localStorage.getItem( 'usuario' ) ).clasificacionId
                    ),
                recuperoContraseña:null,
            }
        case OBTENER_USUARIO:
            return {
                ...state,
                autenticado: true,
                usuario: action.payload,
                cargando: false,
                accesos: getAccesos(
                    action.payload ?
                        action.payload.clasificacionId
                        :
                        JSON.parse( localStorage.getItem( 'usuario' ) ).clasificacionId
                    ),
                recuperoContraseña:null,
            }
        case TOKEN_ERROR:
        case LOGIN_ERROR:
        case REGISTRO_ERROR:
        case RECUPERAR_ERROR:
        case CERRAR_SESION:
            localStorage.removeItem('token');
            localStorage.removeItem('usuario');
            return {
                ...state,
                token: null,
                usuario: null,
                autenticado: null,
                mensaje: action.payload,
                cargando: false,
                accesos: null,
                recuperoContraseña:null,
            }

        default:
            return state;
    }
}